import './Backdrop.scss'

const Backdrop = ({ onClick }) => {
    return (
        <div className={`backdrop ${onClick ? 'clickable' : ''}`} onClick={onClick || null}></div>
    )
}

export default Backdrop